import { render, staticRenderFns } from "./AddDataSource.vue?vue&type=template&id=4860a2a1"
import script from "./AddDataSource.vue?vue&type=script&lang=js"
export * from "./AddDataSource.vue?vue&type=script&lang=js"
import style0 from "./AddDataSource.vue?vue&type=style&index=0&id=4860a2a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports